/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import type { ReactNode } from 'react';
import { Typography } from '@mui/material';

export function Text( {
	children,
	color = 'text.secondary',
	dataTestId = 'quick-start-tip'
}: { children: ReactNode; color?: string; dataTestId?: string } ): ReactNode {
	return (
		<Typography
			fontWeight={ 400 }
			fontSize="14px"
			lineHeight="22px"
			color={ color }
			data-testid={ dataTestId }
		>
			{ children }
		</Typography>
	);
}
